import Braid from "../models/Braid";
import Stripe from '../models/Stripe';
import BraidSequence from '../models/BraidSequence';
import apiClient from '../components/apiClient';

export class BraidService {
    // Braids
    static addBraid(braid: Braid) : Promise<Braid> {
        return apiClient.post<Braid>(`/Braid/AddBraid`, braid).then(res => res.data);
    }

    static getBraids() : Promise<Braid[]> {
        return apiClient.get<Braid[]>(`/Braid/GetBraids`).then(res => res.data);
    }

    static getBraid(id: number) : Promise<Braid> {
        return apiClient.get<Braid>(`/Braid/GetBraid/${id}`).then(res => res.data);
    }

    static deleteBraid(id: number) : Promise<boolean> {
        return apiClient.delete<boolean>(`/Braid/DeleteBraid/${id}`).then(res => res.data);
    }

    static getStripeList() : Promise<Stripe[]> {
        return apiClient.get<Stripe[]>(`/Braid/GetStripeList`).then(res => res.data);
    }

    // Braid Sequences
    static addBraidSequence(braidSequence: BraidSequence) : Promise<BraidSequence> {
        return apiClient.post<BraidSequence>(`/Braid/AddBraidSequence`, braidSequence).then(res => res.data);
    }

    static getBraidSequences(id: number) : Promise<BraidSequence[]> {
        return apiClient.get<BraidSequence[]>(`/Braid/GetBraidSequences/${id}`).then(res => res.data);
    }

    static updateBraidSequence(braidSequence: BraidSequence) : Promise<boolean> {
        return apiClient.put<boolean>(`/Braid/UpdateBraidSequence`, braidSequence).then(res => res.data);
    }

    static deleteBraidSequence(id: number) : Promise<boolean> {
        return apiClient.delete<boolean>(`/Braid/DeleteBraidSequence/${id}`).then(res => res.data);
    }
}